import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HandleRetryService {
  listadoIntentos: Intento[] = [];
  timeToLive = 5;

  constructor() {

  }

  addTryOrBlock(name: string) : boolean{
    this.listadoIntentos.push({
      Nombre: name,
      Fecha: new Date()
    });
    this.listadoIntentos = this.listadoIntentos
    .filter(n => n.Fecha >= new Date(new Date().getTime() - this.timeToLive*60000))
    return this.listadoIntentos.filter(n => n.Nombre == name).length >= 3;
  }

  clear(name: string): boolean{
    this.listadoIntentos = this.listadoIntentos.filter(n => n.Nombre == name);
    return false;
  }
}

export class Intento{
  Nombre: string;
  Fecha: Date
}
